export enum BoxLabelsFormat {
  US_LETTER = "US_LETTER",
  THERMAL_4_X_6 = "THERMAL_4_X_6",
  A4_PAPER = "A4_PAPER",
}
